import { stringToColor, stringToTextColor } from "@utils/utils";

import { Tooltip } from "@fronterahealth/frontera-ui-components";

interface ConnectedObjectBadgesProps {
  names: string[];
  type?: string;
}

export const ConnectedObjectBadges: React.FC<ConnectedObjectBadgesProps> = ({ names, type = "orgs" }) => {
  if (!names || names.length === 0) return null;

  if (names.length === 1) {
    return (
      <span
        className="inline-flex max-h-6 min-w-fit items-center rounded-md px-2 py-1 text-xs font-medium"
        style={{
          backgroundColor: stringToColor(names[0]),
          color: stringToTextColor(names[0]),
        }}
      >
        {names[0]}
      </span>
    );
  }

  return (
    <Tooltip text={names.join(", ")} placement="top" showInfoIcon={false} className="inline-block">
      <span className="inline-flex max-h-6 min-w-fit items-center rounded-md px-2 py-1 text-xs font-medium cursor-pointer bg-gray-200 text-gray-800">
        +{names.length} {type}
      </span>
    </Tooltip>
  );
};
